import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getUserData } from '../services/vpsApi';
import './UserView.css';

function UserView() {
  const { userId } = useParams();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadUserData();
  }, [userId]);

  const loadUserData = async () => {
    try {
      setLoading(true);
      const data = await getUserData(userId);
      setUserData(data);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">載入中...</div>;
  }

  if (error) {
    return <div className="error">錯誤：{error}</div>;
  }

  if (!userData || !userData.user) {
    return <div className="error">找不到使用者</div>;
  }

  return (
    <div className="user-view">
      <header className="user-header">
        <h1 className="page-title">{userData.user.name}</h1>
        <p className="page-subtitle">使用者資料與計時器</p>
      </header>

      <div className="stats-section">
        <div className="stat-card">
          <div className="stat-value">{userData.stats.total}</div>
          <div className="stat-label">總計時器</div>
        </div>
        <div className="stat-card active">
          <div className="stat-value">{userData.stats.active}</div>
          <div className="stat-label">進行中</div>
        </div>
        <div className="stat-card completed">
          <div className="stat-value">{userData.stats.completed}</div>
          <div className="stat-label">已完成</div>
        </div>
      </div>

      <div className="card">
        <h2 className="card-title">我的計時器</h2>
        {userData.timers.length === 0 ? (
          <div className="empty-state">尚無計時器</div>
        ) : (
          <div className="timers-list">
            {userData.timers.map((timer) => (
              <div key={timer.id} className="timer-item">
                <div className="timer-content">
                  <div className="timer-name">{timer.name}</div>
                  <div className="timer-meta">
                    {timer.category && <span className="meta-item">類別：{timer.category}</span>}
                    {timer.duration && <span className="meta-item">時長：{timer.duration}s</span>}
                  </div>
                </div>
                <span className={`status-badge status-${timer.status}`}>
                  {timer.status}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default UserView;
